import Plyr from "plyr";
import "plyr/dist/plyr.css";

new Plyr(".videoplayer");
